/* Layout */
import Layout from '../../views/layout/Layout.vue' 

const RegularEdmList = () => import(/* webpackChunkName: "regular-edm-list" */ '@/views/edm/regular-edm-list')
const RegularEdmDetail = () => import(/* webpackChunkName: "regular-edm-detail" */ '@/views/edm/regular-edm-detail')
const TBREdmList = () => import(/* webpackChunkName: "tbr-edm-list" */ '@/views/edm/tbr-edm-list')
const TBREdmDetail = () => import(/* webpackChunkName: "tbr-edm-detail" */ '@/views/edm/tbr-edm-detail')

export default [
  {
    path: '/edm',
    component: Layout,
    redirect: '/edm/list-regular-edm',
    name: 'edm',
    alwaysShow: true,
    meta: {
      title: 'edm',
      icon: 'images',
    },
    children: [
      {
        path: 'list-regular-edm',
        component: RegularEdmList,
        name: 'RegularEdmList',
        meta: {
          title: 'Regular Edm',
          icon: 'list',
          accessibleName: 'edm',
        },
      },
      {
        path: 'create-regular-edm',
        component: RegularEdmDetail,
        props: true,
        name: 'CreateRegularEdm',
        hidden: true,
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'edm',
        },
      },
      {
        path: 'edit-regular-edm/:id',
        component: RegularEdmDetail,
        props: true,
        name: 'EditRegularEdm',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'edm',
        },
      },
      {
        path: 'list-tbr-edm',
        component: TBREdmList,
        name: 'TBREdmList',
        meta: {
          title: 'TBR Edm',
          icon: 'list',
          accessibleName: 'tbr-edm',
        },
      },
      {
        path: 'create-tbr-edm',
        component: TBREdmDetail,
        props: true,
        name: 'CreateTBREdm',
        hidden: true,
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'tbr-edm',
        },
      },
      {
        path: 'edit-tbr-edm/:id',
        component: TBREdmDetail,
        props: true,
        name: 'EditTBREdm',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'tbr-edm',
        },
      },
    ],
  },
]
